import { Ingredient } from "@/models/Ingredient/Ingredient";
import { CreateRestaurantIngredient } from "@/models/Ingredient/CreateRestaurantIngredient";
import { UpdateRestaurantIngredient } from "@/models/Ingredient/UpdateRestaurantIngredient";

type IngredientNutrientPayload = {
  value: number | null;
  nutrientUnitId: number | null;
};

export function buildCreateRestaurantIngredientPayload(
  ingredient: Ingredient,
  nutrients: IngredientNutrientPayload[]
): CreateRestaurantIngredient {
  return {
    name: ingredient.name,
    weightInGrams: ingredient.weightInGrams,
    measurements: ingredient.allMeasurements,
    unitOfMeasurement: ingredient.unitOfMeasurement,
    categoryDensityId: ingredient.categoryDensityId,
    quantityInUnitOfMeasurement: ingredient.quantityInUnitOfMeasurement,
    nutrients,
    subIngredients: ingredient.subIngredients,
    foodCode: ingredient.foodCode,
    allergens: ingredient.allergens || [],
    mayContainText: ingredient.mayContainText || {},
  };
}

export function buildUpdateRestaurantIngredientPayload(
  ingredient: Ingredient,
  nutrients: IngredientNutrientPayload[]
): UpdateRestaurantIngredient {
  return {
    id: ingredient.id,
    name: ingredient.name,
    weightInGrams: ingredient.weightInGrams,
    measurements: ingredient.allMeasurements,
    unitOfMeasurement: ingredient.unitOfMeasurement,
    categoryDensityId: ingredient.categoryDensityId,
    quantityInUnitOfMeasurement: ingredient.quantityInUnitOfMeasurement,
    nutrients: nutrients as Array<{ value: number; nutrientUnitId: number }>,
    subIngredients: ingredient.subIngredients,
    foodCode: ingredient.foodCode,
    allergens: ingredient.allergens || [],
    mayContainText: ingredient.mayContainText || {},
  };
}

export function getCreatedIngredientId(response: any): number | null {
  if (typeof response?.data?.id === "number") {
    return response.data.id;
  }

  if (typeof response?.data?.result?.id === "number") {
    return response.data.result.id;
  }

  if (typeof response?.data?.result === "number") {
    return response.data.result;
  }

  return null;
}
